module.exports = __webpack_public_path__ + "img/fanying.6d8fa6f9.jpg";